import store from "../config/configureStore";
import settings from "../config/settings";

export const getService = (serviceName = "ams") => {
  let service;
  try {
    const state = store.store.getState();
    const client = state.websocket.websocket;
    service = client.service(serviceName);
    service.timeout = settings.serviceTimeout;
  } catch (err) {
    throw new Error("Error, service not ready.");
  }

  return service;
};
